import "./styles/globals.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Link,
} from "react-router";
import ChatHistory from "./components/Chat/ChatHistory";
import { FrontPage } from "./pages/FrontPage";
import { Toaster } from "sonner";
import Dev from "./pages/Dev";

import Home from "./pages/Home";
import SandboxPage from "./pages/Sandbox";
import { HomeIcon } from "lucide-react";
import ThemeToggle from "./components/ThemeToggle";
import ChatController from "./pages/ChatController";
import { WorkflowProvider } from "./lib/WorkflowContext";

export function App() {
  return (
    <Router>
      <Toaster />
      <div className="relative z-10 min-h-screen bg-background">
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route path="/_dev" element={<Dev />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Home />} />
            <Route path="chat" element={<ChatController />} />
            <Route path=":id" element={<WorkflowProvider />}>
              <Route path="chat" element={<ChatController />} />
              <Route path="history" element={<ChatHistory />} />
              <Route path="sandbox" element={<SandboxPage />} />
            </Route>
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

const AppLayout = () => {
  return (
    <div>
      <header className="fixed pointer-events-none top-0 left-0 right-0 h-12 flex items-center px-4 z-20 m-2 justify-between">
        <Link to="/app">
          <HomeIcon />
        </Link>
        <ThemeToggle />
      </header>
      <Outlet />
    </div>
  );
};

export default App;
